import React from "react"
import ReactDOM from "react-dom"
import FlightSearchHero from "./flight-search-hero-component"

export default class FlightSearchHeroModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.coordinates = elem.dataset.coordinates && JSON.parse(elem.dataset.coordinates)
    self.locale = (document.body && document.body.dataset.language) || "da"
    self.hosts = document.body && document.body.dataset.hosts && JSON.parse(document.body.dataset.hosts)
    self.tabIcons = elem.dataset.tabIcons && JSON.parse(elem.dataset.tabIcons)
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(
      <FlightSearchHero
        {...self.modelJson}
        {...self.tabIcons}
        locale={self.locale}
        coordinates={self.coordinates}
        hosts={self.hosts}
        ipAddress={self.elem.dataset.ipAddress}
      />,
      self.elem,
    )
  }
}
